import React from "react";

import IconoObligatorio from "./IconoObligatorio";

export default function ReferenciaObligatorios() {
  return (
    <div style={{ display: "block", marginBottom: 10 }}>
      <IconoObligatorio />{" "}
      <small className="text-muted">Campos obligatorios</small>
    </div>
  );
}
